<template>
  <div class="spell">
    <Minibar :color="'lightcyan'" :back="true" :val="val" :max="100" />
    <Minibar
      :text="true"
      :color="'purple'"
      :val="spell.exp"
      :max="spell.nexp"
    />
    <div class="text">
      <span>{{ spell.name }}</span>
      <span> ({{ spell.prof }})</span>
    </div>
  </div>
</template>

<script>
import Minibar from "./Minibar";

export default {
  props: {
    spell: Object,
    val: Number,
    max: Number,
  },
  filters: {
    fixed(a) {
      return a.toFixed(2).replace(/\.?0+$/, "");
    },
  },
  components: {
    Minibar,
  },
};
</script>

<style scoped>
.spell {
  height: 20px;
  position: relative;
  user-select: none;
  border: 1px solid black;
  padding: 10px;
  margin: 5px;
  background: lightgray;
  width: 180px;
  user-select: none;
}

.spell:hover {
  background: darkgrey;
}

.text {
  position: relative;
  z-index: 2;
}
</style>